<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
            :parent-component="'tracker-list'"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-10 main-content position-relative">
            <tracker-list
                :customization-owner="user"
                :endpoint="'users'"
                :tracker-types="trackerTypes"
                @set-parent-prop="propSetFromChild($event)"
            ></tracker-list>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import TrackerList from "./tracker/TrackerList";
import { sideMenuItems } from "../plugins/sideMenuItems";

export default {
    name: "CustomizeTrackers",
    props: ["user", "trackerTypes"],
    components: {
        GoLotusSideMenu,
        TrackerList,
    },
    mixins: [sideMenuItems],
};
</script>

<style scoped lang="scss"></style>
